import { useSelector } from 'react-redux';
import FJSlideCompare from '../../../../common/components/FJSlideCompare/FJSlideCompare';
import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import FJActionBrushEditCommon from '../../../../redux/action/FJActionBrushEditCommon';
import useLocalStore from '../../../../hooks/useLocalStore';
import { FJViewCanvasSingleton } from '../js/FJViewCanvas';

const FJCreationEditCompareContainer = memo(function FJCreationEditCompareContainer() {
    useLocalStore();
    const dispatch = useDispatch();

    const editImageRect = useSelector(state => state.brushEditCommon.editImageRect);
    const compareLineScale = useSelector(state => state.brushEditCommon.compareLineScale);
    const originImageSize = useSelector(state => state.brushEditCommon.originImageSize);
    const editImageSize = useSelector(state => state.brushEditCommon.editImageSize);
    const isSlideCompare = useSelector(state => state.brushEditCommon.isSlideCompare);
    const zoom = useSelector(state => state.brushEditCommon.zoom);

    const realCanvasRatio = FJViewCanvasSingleton.getRealCanvasRatio();

    const changeCompareLineScale = useCallback(
        value => {
            dispatch(FJActionBrushEditCommon.updateCompareLineScaleAction(value));
        },
        [dispatch],
    );

    return (
        <FJSlideCompare
            editImageRect={{
                width: editImageRect.width / realCanvasRatio,
                height: editImageRect.height / realCanvasRatio,
                x: editImageRect.x / realCanvasRatio,
                y: editImageRect.y / realCanvasRatio,
            }}
            compareLineScale={compareLineScale}
            originImageSize={originImageSize}
            editImageSize={editImageSize}
            active={isSlideCompare}
            zoom={zoom}
            changeCompareLineScale={changeCompareLineScale}
        />
    );
});

export default FJCreationEditCompareContainer;
